module.exports = __webpack_public_path__ + "static/Q6Answer5_YourSibling_annie_spratt-42d0c5d787c4f400426eb2ba3dbd3305.jpg";